export enum LoanOriginationSystemEmailsFiltersActionTypes {
  SetSearchInputValue = 'loanOriginationSystemEmailsFilters/setSearchInputValue',
  ToggleFiltersPopup = 'loanOriginationSystemEmailsFilters/toggleFiltersPopup',
  ChangePopupFilters = 'loanOriginationSystemEmailsFilters/changePopupFilters',
  ResetAllFilters = 'loanOriginationSystemEmailsFilters/resetAllFilters',
}
